import { ROUTES_PATH } from '@/constants/common.constants';

const handleRedirectNewTab = () => {
  window.open(ROUTES_PATH.inquiryContact, '_blank');
};

export { handleRedirectNewTab };
